// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Root_wrapper__3QAlh"};